import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";
import { dict } from "../i18n";
import { pagePath } from "../lib/routes";

export default function Footer({ lang }) {
  const t = dict[lang];
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 pb-24 sm:pb-0 border-t border-surface-outline/40 bg-white" data-testid="site-footer">
      <div className="container-page py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-sapphire-700 text-white font-semibold">
              TE
            </span>
            <div className="leading-tight">
              <div className="text-[15px] font-semibold text-surface-ink">Tallinna</div>
              <div className="text-[12px] text-surface-inkSoft -mt-0.5">Endokrinoloogia Kliinik</div>
            </div>
          </div>
          <p className="text-[12px] text-surface-inkSoft leading-relaxed font-mono" data-testid="footer-company">
            <span className="font-semibold text-surface-ink">Reveron Baltic OÜ</span><br />
            <span className="font-semibold">{lang === "ru" ? "Лицензии" : lang === "en" ? "Licenses" : "Tegevusload"}:</span><br />
            L05003 · L02510 · L04826 · L04842
          </p>
        </div>

        <div>
          <div className="chip mb-3">{t.sections.locations.tag}</div>
          <ul className="space-y-3 text-[14px] text-surface-ink">
            <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 text-sapphire-700 shrink-0" /><span className="text-[14px] text-surface-ink">Tartu mnt 16, 3. krs, Tallinn<br />sissepääs Rävala puiesteelt<br /><span className="text-surface-inkSoft text-[13px]">{dict[lang].locale.startsWith("et") ? "E–R 10–18" : dict[lang].locale.startsWith("ru") ? "Пн–Пт 10–18" : "Mon–Fri 10–18"}</span></span></li>
            <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 text-sapphire-700 shrink-0" /><span className="text-[14px] text-surface-ink">Metsa 28, Mai apteegi maja<br />ruum 32, Pärnu<br /><span className="text-surface-inkSoft text-[13px]">{dict[lang].locale.startsWith("ru") ? "Вт, Пт и Сб 9–17" : dict[lang].locale.startsWith("en") ? "Tue, Fri & Sat 9–17" : "T, R ja L 9–17"}</span></span></li>
          </ul>
        </div>

        <div>
          <div className="chip mb-3">{t.nav.contact}</div>
          <ul className="space-y-2 text-[14px]">
            <li><a href="tel:+37255665451" className="flex items-center gap-2 text-surface-ink hover:text-sapphire-700"><Phone className="h-4 w-4" />+372 5566 5451</a></li>
            <li><a href="tel:+37255665135" className="flex items-center gap-2 text-surface-ink hover:text-sapphire-700"><Phone className="h-4 w-4" />+372 5566 5135</a></li>
            <li><a href="mailto:info@endokrinoloog.ee" className="flex items-center gap-2 text-surface-ink hover:text-sapphire-700"><Mail className="h-4 w-4" />info@endokrinoloog.ee</a></li>
          </ul>
        </div>

        <div>
          <div className="chip mb-3">{t.nav.book}</div>
          <a
            href="https://veebiregistratuur.ee/#/tallinna-endokrinoloogia-kliinik/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[14px] font-medium text-sapphire-700 hover:underline"
            data-testid="footer-digireg-link"
          >
            {t.footer.digital}
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
          <div className="mt-3 flex flex-col gap-2">
            <Link to={pagePath("contact", lang)} className="text-[14px] text-surface-ink hover:text-sapphire-700">{t.cta.emailUs}</Link>
            <Link to={pagePath("pricing", lang)} className="text-[14px] text-surface-ink hover:text-sapphire-700">{t.nav.pricing}</Link>
            <Link to={pagePath("calculators", lang)} className="text-[14px] text-surface-ink hover:text-sapphire-700" data-testid="footer-calculators-link">{lang === "et" ? "Tervisekalkulaatorid" : lang === "ru" ? "Калькуляторы здоровья" : "Health calculators"}</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-surface-outline/40">
        <div className="container-page py-5 text-[12px] text-surface-inkSoft text-center">
          © {year} Tallinna Endokrinoloogia Kliinik. {t.footer.rights}.
        </div>
      </div>
    </footer>
  );
}
